import React, { useEffect } from 'react';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated';
import Colors from '../constants/Colors';
import { StyleProp, ViewStyle } from 'react-native';

type LoadingSkeletonProps = {
  style: StyleProp<ViewStyle>;
};

/**
 * A gray skeleton to display while an actual component is loading.
 * The component will "pulse" in color opacity to signal a loading state to the user
 */
export function LoadingSkeleton(props: LoadingSkeletonProps) {
  const opacity = useSharedValue(0);
  const animatedStyles = useAnimatedStyle(() => {
    return {
      opacity: opacity.value,
    };
  });

  useEffect(() => {
    opacity.value = withSequence(
      // Animate from 0 to 1; we start at an opacity of 0 so that
      // if this loading skeleton is only displayed for hundreds
      // of ms, it won't "flash" at full gray
      withTiming(1, { duration: 1000 }),
      // Then, animate between 1 and 0.5 opacity every 700 ms
      withRepeat(withTiming(0.5, { duration: 700 }), 0, true)
    );
  }, []);

  return (
    <Animated.View
      style={[
        { height: 20, width: 60, backgroundColor: Colors.lightGray, borderRadius: 8 },
        props.style,
        animatedStyles,
      ]}
    ></Animated.View>
  );
}
